module.exports = __webpack_public_path__ + "static/media/Jaochim.a4d52db2.jpeg";